import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParametroAutonomiaRoutingModule } from './parametro-autonomia.routing';
import { ParametroAutonomiaComponent } from './parametro-autonomia.component';
import { MatButtonModule, MatInputModule, MatTableModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FabButtonGroupModule } from 'src/app/shared/fabbuttongroup/fabbuttongroup.module';
import { SectionBarModule } from 'src/app/shared/sectionbar/sectionbar.module';
import { GridEmptyModule } from 'src/app/shared/gridempty/gridempty.module';
import { HeaderModule } from 'src/app/shared/header/header.module';
import { TitlebarModule } from 'src/app/shared/titlebar/titlebar.module';
import { LoaderModule } from 'src/app/shared/loader/loader.module';
import { SnackbarModule } from 'src/app/shared/snackbar/snackbar.module';
import { ParametroAutonomiaListComponent } from './list/parametro-autonomia-list.component';
import { ParametroAutonomiaSaveComponent } from './save/parametro-autonomia-save.component';
import { ParametroAutonomiaViewComponent } from './view/parametro-autonomia-view.component';

@NgModule({
  imports: [
    CommonModule,
    ParametroAutonomiaRoutingModule,
    MatTableModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    FabButtonGroupModule,
    SectionBarModule,
    GridEmptyModule,
    TitlebarModule,
    HeaderModule,
    LoaderModule,
    SnackbarModule
  ],
  declarations: [
    ParametroAutonomiaListComponent,
    ParametroAutonomiaSaveComponent,
    ParametroAutonomiaViewComponent,
    ParametroAutonomiaComponent
  ]
})
export class ParametroAutonomiaModule { }
